import React from 'react';
import glamorous from 'glamorous';

import { breakpoints, media } from '../../styles';

const style = props => ({
  flexGrow: 2,
  width: '100%',
  margin: '0 auto',
  maxWidth: breakpoints('lg'),
  paddingLeft: props.hasNoPaddingUnderSm ? 0 : 8,
  paddingRight: props.hasNoPaddingUnderSm ? 0 : 8,

  [media('sm')]: {
    paddingLeft: 16,
    paddingRight: 16,
  },

  ...props.glamStyle,
});

const baseStyle = style({});
const Div = glamorous.div(baseStyle, style);

class MainContent extends React.PureComponent {
  render() {
    const {
      children,
      style,
      ...rest,
    } = this.props;

    return (
      <Div {...rest} glamStyle={style}>
        {children}
      </Div>
    );
  }
}

export default MainContent;



// WEBPACK FOOTER //
// ./src/components/layout/MainContent.js